import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {TellerKomponent} from "web-ng2/delt/komponenter/teller/teller";

const debug = initDebugger('IkonMedTellerKomponent');

/**
 * Viser ikon med en rød sirkel i øvre høyre hjørne med et tall i
 */
@Component({
    selector: 'ikon-med-teller',
    templateUrl: 'ikon-med-teller.html',
    styleUrl: 'ikon-med-teller.scss',
    imports: [
        MatIcon,
        TellerKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IkonMedTellerKomponent {

    teller = input.required<number>();
    skjulTellerDersomNull = input(false, {transform: booleanAttribute});
    fontSet = input('lederplan-ikon-dokument');
    class = input('');

    constructor() {

    }
}

